package com.xtream.data_kmp.db.repo

import com.xtream.data_kmp.db.AppRoomDB
import com.xtream.data_kmp.dto.BaseStream
import com.xtream.data_kmp.dto.CategoryBase
import com.xtream.data_kmp.dto.CategoryWithStream
import com.xtream.data_kmp.dto.LiveCategory


class SearchStreamsRepository (
    private val db: AppRoomDB
){




    private suspend fun buildRow(id: Int, query: String?): List<CategoryWithStream<BaseStream, CategoryBase>> {
        val streams: List<BaseStream> = when (id) {
            1 -> db.liveStreamsDao().all(null, query, offset = 0, limit = 20)
            2 -> db.vodDao().all(null,query, offset = 1, limit = 20)
            3 -> db.seriesDao().all(null, query, offset = 0, limit = 20)
            else -> emptyList()
            }
        if (streams.isEmpty()) return emptyList()

        return listOf(
            CategoryWithStream(
                size = -1,
                streams = streams,
                category = when (id) {
                    1 -> LiveCategory(1, "TV Channels", null)
                    2 -> LiveCategory(2, "Movies", null)
                    3 -> LiveCategory(3, "Series", null)
                    else -> LiveCategory(-1, "", null)
                }
            )
        )
    }











}

